// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.eyefinity.OrderEyefinityFeeMappingResponse */
/* istanbul ignore next */
@GandalfModel
export class OrderEyefinityFeeMappingResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	eyefinityFeeMappingId!: number | null;

	@GandalfProperty({ designType: String })
	feeOptionCode!: string | null;

	@GandalfProperty({ designType: String })
	hcpcsCode!: string | null;

	@GandalfProperty({ designType: Number })
	locationProductId!: number | null;

	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	retailCost!: number | null;

}
